import { Component, OnInit, Input } from '@angular/core';

import { TransactionInvoiceService } from 'src/app/pages/transaction/services/transaction-invoice.service';
import { CostFormService } from 'src/app/core/services/cost-form.service';

import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
import { MultiLanguageService } from 'src/app/core/services/multi-language.service';
import { DynamicFormService } from 'src/app/core/services/dynamic-form.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { keyframes } from '@angular/animations';
import { Key } from 'protractor';
import { timeStamp } from 'console';

@Component({
  selector: 'tr.transaction-cost-item',
  templateUrl: './cost-item.component.html',
  styleUrls: ['./cost-item.component.scss']
})
export class CostItemComponent implements OnInit {
  @Input('cost') cost;
  @Input('invoice') invoice;

  canEdit: boolean = false;
  
  selected: boolean = false;
  qty: any = 1;
  total: any = 0;
  placeholder: any;
  isRequired: boolean = false;
  isInformative: boolean = false;

  constructor(
    private mainService: CostFormService,
    private transactionService: TransactionService,    
    public multiLanguageService: MultiLanguageService,
    public dynamicFormService: DynamicFormService,
    public authService: AuthService,
  ) { 
  }

  ngOnInit() {
    console.log(this.cost);
    console.log(this.transactionService.itemToEdit);
    if(!this.cost.IsInformative && !this.cost.IsRequired){
      this.cost.requiresMininum = true;
      this.cost.currentCostQty = 0;
      this.mainService.minRequiredCosts.push(this.cost);

      console.log('this.minRequiredCosts: ' + JSON.stringify(this.mainService.minRequiredCosts))
    }

    if(this.cost.IsInformative){
      this.isInformative = true;
    }
    if(this.cost.IsRequired){
      this.selected = true;
      this.isRequired = true;
      this.qty = this.cost.Qty;

      this.calculate(null);
    }
    if(this.cost.IsSelected){
      this.selected = true;
      this.qty = this.cost.Qty;

      this.calculate(null);
    }

    this.canEdit = (this.dynamicFormService.transactionService.itemToEdit.Radicated) ? false : true;
  }
  
  calculate(valueType){

    if(this.selected){
      if(this.cost.FixedAmount>0){
        this.total = this.cost.FixedAmount;
      }else{
        
        this.total = this.qty * this.cost.Amount;
      }
      if(this.cost.FixedAmount>0){
        this.mainService.manageCost({
          cost: this.cost,
          qty: (this.cost.FixedAmount>0) ? 1 : this.qty
        });
      }
      if(this.cost.FixedAmount==0){
        this.mainService.manageCost({
          cost: this.cost,
          qty: this.qty
        });
      }
    }
    if(!this.selected)
    {
      this.qty = 1;
      this.mainService.removeCost(this.cost);
    }
    let count: any = 0
    this.mainService.minimumCostsAdded = true;
    for(var i = 0; i < this.mainService.selectedCosts.length; i++){     
      if(!this.mainService.selectedCosts[i].IsRequired){
        count+=1;
      }
    }
    console.log('min Cost Count: ' + count)
    if(count < this.cost.Min){
      this.mainService.minimumCostsAdded = false;
    }
    console.log('Array Count: ' + this.mainService.selectedCosts.length);
   
    this.mainService.setInvoiceTotal();   
  }
}
